import React from "react";
import Profile from "../../components/UserProfile";

const ProfilePage = () => {
  return (
      <Profile />
  );
};

export default ProfilePage;